import { combineReducers } from 'redux';

import findUser from './findUser';
import login from './login';
import password from './password';
import auth from './auth';
import comments from './comments';
import datepickers from './datepickers';
import activity from './activity';
import userExplorer from './userExplorer';
import communication from './communication';
import paymentsInfo from './paymentsInfo';
import product from './product';
import map from './map';
import mapField from './mapField';
import mapFieldList from './mapFieldList';
import subscription from '../modules/PaymentSubscription/reducers/subscription';
import subFormOptions from '../modules/PaymentSubscription/reducers/subFormOptions';
import subFormSend from '../modules/PaymentSubscription/reducers/subFormSend';
import existSubscription from '../modules/PaymentSubscription/reducers/existSubscription';
import subToaster from '../modules/PaymentSubscription/reducers/subToaster';

const rootReducer = combineReducers({
  comments,
  findUser,
  login,
  password,
  auth,
  datepickers,
  activity,
  userExplorer,
  communication,
  paymentsInfo,
  product,
  map,
  mapField,
  mapFieldList,
  subscription,
  subFormOptions,
  subFormSend,
  existSubscription,
  subToaster,
});

export default rootReducer;
